<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    confirm-text="保存"
    :title="createForm.id?'修改优惠券' :'新增优惠券'"
    width="30%"
    :confirm-disable="false"
    @confirm="confirm"
    @close="close"
  >
    <div class="content">
      <el-form
        ref="createForm"
        :model="createForm"
        :rules="creatRules"
        label-width="100px"
      >
        <el-form-item
          label="用户手机"
          prop="userMobilePhone"
        >
          <el-input v-model="createForm.userMobilePhone" />
        </el-form-item>

        <el-form-item
          label="优惠券"
          prop="couponId"
        >
          <el-select
            v-model="createForm.couponId"
            filterable
            clearable
            placeholder="请选择优惠券"
          >
            <el-option
              v-for="coupon in couponList"
              :key="coupon.id"
              :label="getCouponTypeName(coupon)"
              :value="coupon.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </div>
  </custome-Dialog>
</template>
<script>
import customeDialog from '@/components/common/dialog.vue';
import axClient from '@/services';
import { couponTypeList } from '@/config';

export default {
  name: 'ProductDialog',
  components: { customeDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: [Object, null],
      default: null,
    },
  },
  data() {
    return {
      couponTypeList,
      cancelText: '取消',
      couponList: [],
      createForm: {
        userMobilePhone: null,
        couponId: null,
      },
      creatRules: {
        userMobilePhone: [
          { required: true, message: '请输入用户手机号', trigger: 'blur' },
        ],
        couponId: [
          { required: true, message: '请选择对应课程', trigger: 'blur' },
        ],
      },
    };
  },
  watch: {
    item: {
      handler(val) {
        this.$nextTick(() => {
          if (val) {
            const {
              userMobilePhone,
              couponId,
            } = val;
            this.createForm = {
              userMobilePhone,
              couponId,
            };
          }
        });
      },
      deep: true,
    },
  },
  mounted() {
    this.getCouponSelect();
  },
  methods: {
    close() {
      this.$emit('update:dialogVisible', false);
      this.$emit('close');
      this.$refs.createForm.clearValidate();
      this.$refs.createForm.resetFields();
    },
    confirm() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          this.createForm.discountFee *= 100;
          const data = await axClient.coupon.userCouponInsert(this.createForm);
          if (!data) return;
          this.$message.success('新增用户优惠券成功');
          this.$emit('update:dialogVisible', false);
          this.$emit('confirm');
          this.$refs.createForm.clearValidate();
          this.$refs.createForm.resetFields();
        }
      });
    },
    getCouponTypeName(item) {
      // const couponType = couponTypeList.filter((coupon) => coupon.value === 40)[0];
      return `${item.couponName}`;
    },
    async getCouponSelect() {
      this.couponList = await axClient.coupon.couponSelect({ couponType: null });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  min-height: 200px;
}

</style>
